import { useSelector } from 'react-redux';
import { useModalContext } from 'modules/experiments/contexts';
import {
  useEndExperiment,
  useExperimentsTranslations,
  useExperimentsUserPermission,
} from 'modules/experiments/hooks';
import { ExperimentSummaryRowDataProps } from 'modules/experiments/types';
import { getCampaignMessageMedium } from 'modules/experiments/ducks/selectors';
import { DisabledTooltip } from 'modules/experiments/components/pages/CommonStyled';
import { MODAL_VARIANTS } from 'ui/modal';
import { SecondaryButton } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { TextNoWrap } from './Styled';
import { RowCell } from './RowCell';

export const UseVariantCell = ({ row }: ExperimentSummaryRowDataProps) => {
  const { t } = useExperimentsTranslations();
  const campaignMessageMedium = useSelector(getCampaignMessageMedium);
  const { nonManageAndLaunchPermission } = useExperimentsUserPermission(campaignMessageMedium);
  const { showModal, hideModal } = useModalContext();
  const { variantTemplateID, experimentID, winner } = row;
  const declareWinner = useEndExperiment({
    id: experimentID,
    winningTemplateId: variantTemplateID,
    onComplete() {
      hideModal();
    },
  });

  const TooltipComponent = nonManageAndLaunchPermission ? DisabledTooltip : Tooltip;

  return (
    <RowCell
      isWinner={winner.toString()}
      dataTestId={`use-variant-button-cell-${variantTemplateID}`}
    >
      <TooltipComponent
        tooltipContent={
          nonManageAndLaunchPermission
            ? t('permissions.declareWinner')
            : t('variantTable.tooltip.useVariant')
        }
      >
        <TextNoWrap>
          <SecondaryButton
            data-test={`use-variant-button-${variantTemplateID}`}
            isDisabled={nonManageAndLaunchPermission}
            onClick={() =>
              showModal({
                variant: MODAL_VARIANTS.WARNING,
                id: 'use-variant',
                title: t('variantTable.modal.header'),
                body: t('variantTable.modal.body'),
                buttonText: t('variantTable.modal.buttonText'),
                inProgressButtonText: t('variantTable.modal.progress'),
                isDestructive: false,
                onConfirm: () => {
                  if (!experimentID) return;
                  declareWinner();
                },
              })
            }
          >
            {t('variantTable.cell.useVariant')}
          </SecondaryButton>
        </TextNoWrap>
      </TooltipComponent>
    </RowCell>
  );
};
